import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrypto = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 3.00507V21.3047",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6894 12.1004L12 15.75L4.32812 12.134",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2137 2.50077C11.6141 1.9912 12.3859 1.9912 12.7863 2.50077L19.7646 11.3822C20.0495 11.7448 20.0495 12.2552 19.7646 12.6178L12.7863 21.4992C12.3859 22.0088 11.6141 22.0088 11.2137 21.4992L4.23543 12.6178C3.95052 12.2552 3.95052 11.7448 4.23543 11.3822L11.2137 2.50077Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCrypto;
